import React, { FC, useMemo } from 'react'
import { FCC } from 'types'
import { CreditsContext } from './CreditsContext'
import { TCreditType } from '../types'

const CreditsProvider: FCC<{
 type?: TCreditType
}> = ({ type, children }) => {
 const value = useMemo(() => ({ type }), [type])
 return (
  <CreditsContext.Provider value={value}>{children}</CreditsContext.Provider>
 )
}

export default CreditsProvider
